<template>
  <span class="dropdown"
        v-if="seasons">
    <fas
        type="button"
        icon="caret-down"
        size="1x"
        class="mb-0 dropdown-toggle"
        data-toggle="dropdown"
    />
    <div class="dropdown-menu scrollable">
      <li v-for="season in seasons"
          :key="season.id"
          @click="$emit('input', season)"
          class="dropdown-item">
        {{ season.name }}
      </li>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: Object,
    challengeId: Number,
    open: Boolean
  },
  data() {
    return {
      seasons: null
    }
  },
  methods: {
    loadSeasons() {
      this.$api.get('/seasons', {params: {challenge: this.challengeId}})
          .then(response => this.seasons = response.data)
    }
  },
  watch: {
    challengeId() {
      this.loadSeasons()
    }
  },
  mounted() {
    this.loadSeasons()
  }
}
</script>

<style>
.scrollable {
  max-height: 250px;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scroll-snap-type: y proximity;
}

.scrollable > li:last-child {
  scroll-snap-align: end;
}
</style>